import React from 'react';

import { Footer } from '../../../layout/footer/Footer';
import { Page } from '../../../contexts/kioskConfiguration/type';
import { MainContent } from '../../../layout/content/MainContent';


export type MapTemplateType = {
  url?: string
  imageUrl?: string
}

type Props = {
  page: Page<MapTemplateType>
}


export const MapTemplate = (props: Props): React.ReactElement => {

  return (
    <>
      <MainContent>
        {props.page.data.url && (
          <iframe src={props.page.data.url} style={{ border: 0, width: '100%', height: '100vh' }} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        )}
        {props.page.data.imageUrl && (
          <img src={`${process.env.APP_DATA_LINK + props.page.data.imageUrl}`} className="w-full" alt=""/>
        )}
      </MainContent>

      <Footer backUrl={props.page.footer?.back}/>
    </>
  )
}
